import {makeAutoObservable} from 'mobx';

import {ContactFormStore} from '../Agent/ContactForm/ContactFormStore/ContactFormStore';
import {Form} from './Form';
import API from '../APIs/API';
import Utils from '../Core/Utils';
import {ParameterStore} from '../Core/mobx/ParameterStore/ParameterStore';
import type {RootStore} from '../Core/mobx/RootStore';

export class CaseManagerStore {
    contactsFormStore = new ContactFormStore(this);
    parameterStore = new ParameterStore();
    forms: Form[] = [];

    constructor(private parentStore: RootStore) {
        makeAutoObservable(this);
    }

    getAgentsList() {
        return this.parentStore.agentsList;
    }

    async getForms() {
        // eslint-disable-next-line no-plusplus
        for (let i = 0; i < 7; i++) {
            // eslint-disable-next-line no-await-in-loop
            const day = (await API.Call(`agent-activity/${Utils.Date2Str(new Date(), -i)}`, 'GET')) as Array<Form>;
            this.forms = this.forms.concat(day);
        }
    }

    async selectForm({id, email, historyId}: {id: string; email: string; historyId?: string}) {
        return this.contactsFormStore.selectForm({id, email, historyId});
    }

    async startFamilyForm({id, email}: {id: string; email: string}) {
        return this.contactsFormStore.startFamilyForm({id, email});
    }
}
